<template>
    <div>
        <v-tooltip bottom>
            <template v-slot:activator="{ on: tooltip }">
                <v-btn v-if="mode==0 && (bank == null || bank.bankId < 1)" class="mr-1" small color="primary" v-on="tooltip" dark @click="chooseBank">
                    <v-icon>mdi-plus</v-icon>
                </v-btn>
                <v-btn 
                    v-else 
                    class="mr-1" small color="primary" dark 
                    v-on="{...tooltip}" 
                    v-on:click="() => dialog = !dialog" 
                >
                    <v-icon>{{`${ (mode === 0) ? 'mdi-plus' : 'mdi-pencil-outline' }`}}</v-icon>
                </v-btn>        
            </template>
            <span>{{ `${ (mode === 0) ? $t('referenceBooks.branches.Create') : $t('referenceBooks.branches.Edit')}` }}</span>
        </v-tooltip>
        <DragForm
                v-model="dialog"
        >
            <v-card width="800">
                <v-card-title>
                    <span class="headline">{{ `${ (mode === 0) ? $t('referenceBooks.branches.Create') : $t('referenceBooks.branches.Edit')}` }}</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <v-text-field 
                                    v-model="currentBranch.bankName" 
                                    :disabled="true"
                                    :label="$t('referenceBooks.banks.Bank') + '*'"
                                    required
                                />
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                                <v-text-field 
                                    v-model="currentBranch.name" 
                                    :label="$t('referenceBooks.branches.Name') + '*'" 
                                    required
                                    :error-messages="branchErrorMessage"
                                    v-on:blur="() => { this.branchWasBlurred = true }"
                                />
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                                <v-text-field 
                                    v-model="currentBranch.address" 
                                    :label="$t('referenceBooks.branches.Address')"
                                />
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                                <v-text-field 
                                    v-model="currentBranch.alias" 
                                    :label="$t('referenceBooks.branches.Alias') + '*'" required                                
                                    :error-messages="aliasErrorMessage"
                                    v-on:blur="() => { this.aliasWasBlurred = true }"
                                />
                            </v-col>

                        </v-row>
                    </v-container>
                    <small>*{{$t('referenceBooks.requiredFields')}}</small>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialog = false">{{$t('Close')}}</v-btn>
                    <v-btn v-if="mode===0" color="blue darken-1" text @click="createBranch">{{$t('Create')}}</v-btn>
                    <v-btn v-else color="blue darken-1" text @click="saveBranch">{{$t('Save')}}</v-btn>
                </v-card-actions>
            </v-card>
        </DragForm>
    </div>
</template>

<script>
import Vue from 'vue';
import {notifyError, notifySuccess} from '@/services/notifications';
import DragForm from '@/components/Forms/DragForm.vue';
export default {
  components: {
    DragForm,
  },
  name: 'BranchDialog',
  props: {
    mode: {
      type: Number,
      defaultItem: 0
    },
    branch: {
      type: Object,
      defaultItem: {
        branchId: -1,
        name: '',
        bankId: -1,
        bankName: '',
        address: '',
        alias: '',
        parentBranchId: 0,
      }
    },
    bank: {
      type: Object,
      defaultItem: {
        bankId: 0,
        bankName: '',
        description: '',
      },
    }
  },
  data(){
    return {
      currentBranch: {
        branchId: -1,
        name: '',
        bankId: -1,
        bankName: '',
        address: '',
        alias: '',
        parentBranchId: 0,
      },
      banks: [],
      dialog: false,
                
      busyValues:{
        'Name': [],
        'Alias': [],
      },
      bankWasBlurred: false,
      branchWasBlurred: false,
      aliasWasBlurred: false,
      executeButtonClick: false,
    };
  },
  watch: {
    dialog(flag) {
      if(!flag)
        this.clear();
      else if (this.mode === 0)
        this.loadModeNull();
      else    
        this.loadModeOne();
                
    }
  },
  computed:{                
    propertiesResponse() {
      return { 
        'Name' : this.$t('referenceBooks.branches.Name'),
        'Alias' : this.$t('referenceBooks.Alias')
      };
    },
    bankErrorMessage(){
      if (this.currentBranch.bankId < 1)
        return this.$t('validations.notEmpty');

      return '';
    },
    aliasErrorMessage(){
      const name = this.currentBranch.alias;
      const check = this.executeButtonClick || 
                            this.aliasWasBlurred ||
                            name != null && name.length != 0;
                            
      if (!check)
        return '';

      return this.checkText(name, 'Alias');
    },
    branchErrorMessage(){
      const name = this.currentBranch.name;
      const check = this.executeButtonClick || 
                            this.branchWasBlurred ||
                            name != null && name.length != 0;
                            
      if (!check)
        return '';

      return this.checkText(name, 'Name');
    },
  },
  methods: {
    getBanks(){
      this.$axios.banks.get()
        .then(response => response.data)
        .then(json => this.banks = json)
        .catch(error => console.error(error));
    },
    getBranch(){
      this.$axios.branches.getById(this.branchId)
        .then(response => response.data)
        .then(json => this.currentBranch = json[0])
        .catch(error => console.error(error));
    },
    chooseBank(){
      this.showMessage(this.$t('Error'), this.$t('referenceBooks.banks.ChooseSomeBank'), 'error');
    },
    checkFields(){
      let result = true;
      let errors = this.checkText(this.currentBranch.name, 'Name');

      if (errors != null && errors != ''){
        this.showMessage(`${this.$t('ErrorInField')}: ${this.$t('referenceBooks.branches.Name')}`, errors, 'error');
        result = false;
      }

      errors = this.checkText(this.currentBranch.alias, 'Alias');

      if (errors != null && errors != ''){
        this.showMessage(`${this.$t('ErrorInField')}: ${this.$t('referenceBooks.Alias')}`, errors, 'error');
        result = false;
      }

      return result;
    },
    checkText(value, ind = null){
      if (value == null || value.length == 0) 
        return this.$t('validations.notEmpty');
                
      if(ind != null){
        if(this.busyValues[ind] != null && this.busyValues[ind].length != 0)
          if (this.busyValues[ind].indexOf(value, 0) != -1)
            return this.$t('errorsMessages.BusyName');
      }

      return '';
    },
    loadModeOne(){
      if(this.branch != null){
        Object.assign(this.currentBranch, this.branch);
      }
    },
    loadModeNull(){
      if(this.bank != null){
        this.currentBranch.bankId = this.bank.bankId;
        this.currentBranch.bankName = this.bank.bankName;
      }
    },
    clear(){
      this.bankWasBlurred = false;
      this.branchWasBlurred = false;
      this.aliasWasBlurred = false;
      this.executeButtonClick = false;
                
      this.busyValues = {
        'Name': [],
        'Alias': [],
      },

      this.currentBranch = {
        branchId: -1,
        name: '',
        bank: -1,
        bankName: '',
        address: '',
        alias: '',
        parentBranchId: 0,
      };
    },
    catchErrors(error, errorHeader = ''){
      const status = error.response.status;
      const data = [error.response.data];

      if (status === 400 || status === 401){
        for(let i = 0; i < data.length; i++)
          this.handlingError(data[i], errorHeader, error);
      }
      else{
        this.onUnknownError(error);
      }
    },
    handlingError(data, errorHeader, error){
      switch(data.errorType){
      case 'IS_BUSY':
        this.onBusy(data.property, data.value);
        break;
      case 'NO_RIGHTS':
        this.onNoRigths(errorHeader);
        break;
      default:
        this.onUnknownError('error', error);
        break;
      }
    },
    onBusy(property, value){
      this.busyValues[property].push(value);
      const errorInField = `${this.$t('ErrorInField')}: ${this.propertiesResponse[property]}`;

      this.showMessage(errorInField, this.$t('errorsMessages.BusyName'), 'error'); 
    },
    onNoRigths(errorHeader = ''){
      this.showMessage(
        `${errorHeader === '' ? this.$t('Error') : errorHeader}`,
        this.$t('errorsMessages.NoRights'),
        'error'
      );
    },
    onUnknownError(error){
      this.$emit('error', error);
    },
    createBranch(){
      this.executeButtonClick = true;

      if (!this.checkFields())
        return;

      const name = this.currentBranch.name;

      this.$axios.branches.post(
        {
          ...this.currentBranch
        }
      )
        .then(response => {
          if (response.status == 200){
            const id = response.data;
            notifySuccess('', this.$t('Messages.BranchWasCreated', [this.currentBranch.name]));

            this.$emit('created', response.status, name, id);
            this.dialog = false;
          }
        })
        .catch(error => {
          console.error(error);
                        
          notifyError('', this.$t('Messages.ErrorOccuredWhileCreatingBranch', [this.currentBranch.name]));
          this.catchErrors(error);
        });
    },
    saveBranch(){
      this.executeButtonClick = true;

      if (!this.checkFields())
        return;

      this.$axios.branches.put(this.currentBranch.branchId, this.currentBranch)
        .then(response => {
          notifySuccess('', this.$t('Messages.BranchWasEdited', [this.currentBranch.name]));
          this.$emit('saved', response.status, this.currentBranch);
          this.dialog = false;
        })
        .catch(error => {
          notifyError('', this.$t('Messages.ErrorOccuredWhileEditingBranch', [this.currentBranch.name]));
          this.catchErrors(error);
        });
    },
    showMessage(title, text, type = ''){
      Vue.notify({
        group: 'notif',
        title: title,
        text: text,
        type: type,
      });
    },
            
  },
  async mounted(){

    /*
                branchId: 1
                name: "Отделение №1 (НБУ)"
                bankId: 1
                address: ""
                alias: "01NBU"
                parentBranchId: 0
             */

  }

};
</script>